const stringToArray = (str) =>
  str
    .split("\n")
    .map((s) => s.trim())
    .filter(Boolean);

export default stringToArray;
